export default "__VITE_ASSET__coPOWpEi__"